"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = CardCalendar;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _Badge = _interopRequireDefault(require("../../Badge"));
var _PickerPanel = _interopRequireDefault(require("rc-picker/lib/PickerPanel"));
var _moment = _interopRequireDefault(require("rc-picker/lib/generate/moment"));
var _StyledCardCalendar = require("./StyledCardCalendar");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function CardCalendar(_ref) {
  var theme = _ref.theme,
    footer = _ref.footer,
    prefixCls = _ref.prefixCls,
    locale = _ref.locale,
    customDates = _ref.customDates,
    width = _ref.width,
    borderless = _ref.borderless,
    onSelect = _ref.onSelect;
  var _useState = (0, _react.useState)([]),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    flattenDates = _useState2[0],
    setFlattenDates = _useState2[1];
  (0, _react.useEffect)(function () {
    var tempFlattenDates = [];
    customDates.map(function (item, index) {
      if (Array.isArray(item.date)) {
        item.date.map(function (x) {
          tempFlattenDates.push({
            title: item.title,
            date: x,
            color: theme.calendar.card.footer.badge.colors[index]
          });
        });
      } else if (item.date.isValid()) {
        tempFlattenDates.push({
          title: item.title,
          date: item.date,
          color: theme.calendar.card.footer.badge.colors[index]
        });
      }
    });
    setFlattenDates(tempFlattenDates);
  }, [customDates]);
  function dateRender(currentDate, today) {
    var matchingDates = flattenDates.filter(function (item) {
      return currentDate.isSame(item.date, 'day');
    });
    if (matchingDates.length > 0) {
      return /*#__PURE__*/_react.default.createElement(_StyledCardCalendar.DateContainer, {
        className: "-cell-inner"
      }, /*#__PURE__*/_react.default.createElement(_StyledCardCalendar.DateWrapper, null, /*#__PURE__*/_react.default.createElement(_StyledCardCalendar.Day, null, " ", currentDate.date()), /*#__PURE__*/_react.default.createElement(_StyledCardCalendar.BadgeMultipleWrapper, null, matchingDates.map(function (item, idx) {
        return /*#__PURE__*/_react.default.createElement(_Badge.default, {
          key: idx,
          colorDot: item.color
        });
      }))));
    }
    var toRender = /*#__PURE__*/_react.default.createElement(_StyledCardCalendar.DateContainer, {
      className: "-cell-inner"
    }, /*#__PURE__*/_react.default.createElement(_StyledCardCalendar.DateWrapper, null, /*#__PURE__*/_react.default.createElement(_StyledCardCalendar.Day, null, currentDate.date())));
    flattenDates.map(function (item) {
      if (currentDate.isSame(item.date, 'day')) {
        var day = currentDate.date();
        toRender = /*#__PURE__*/_react.default.createElement(CustomDate, {
          day: day,
          color: item.color
        });
      }
    });
    return toRender;
  }
  function CustomDate(_ref2) {
    var day = _ref2.day,
      color = _ref2.color;
    return (
      /*#__PURE__*/
      //TODO classname için daha sonra düzenleme yapılacak
      _react.default.createElement(_StyledCardCalendar.DateContainer, {
        className: "-cell-inner"
      }, /*#__PURE__*/_react.default.createElement(_StyledCardCalendar.DateWrapper, null, /*#__PURE__*/_react.default.createElement(_StyledCardCalendar.Day, null, " ", day), /*#__PURE__*/_react.default.createElement(_Badge.default, {
        colorDot: color
      })))
    );
  }
  function footerWithBadges() {
    var noDuplicatedFlattenDates = [];
    var controlArray = [];
    flattenDates.map(function (date) {
      if (!controlArray.includes(date.title)) {
        controlArray.push(date.title);
        noDuplicatedFlattenDates.push(date);
      }
    });
    return /*#__PURE__*/_react.default.createElement(_StyledCardCalendar.FooterWithBadges, null, /*#__PURE__*/_react.default.createElement(_StyledCardCalendar.BadgeWrapper, null, noDuplicatedFlattenDates.map(function (date, index) {
      return /*#__PURE__*/_react.default.createElement(_Badge.default, {
        colorDot: date.color,
        text: date.title,
        key: index
      });
    })), footer);
  }
  return /*#__PURE__*/_react.default.createElement(_StyledCardCalendar.CardCalendarWrapper, {
    theme: theme,
    prefixCls: prefixCls,
    $width: width,
    borderless: borderless
  }, function (styledPrefix) {
    return /*#__PURE__*/_react.default.createElement(_PickerPanel.default, {
      generateConfig: _moment.default,
      locale: locale,
      prefixCls: styledPrefix,
      renderExtraFooter: footerWithBadges,
      dateRender: dateRender,
      onSelect: onSelect
    });
  });
}